module.exports = __webpack_public_path__ + "img/542.c81122ae.png";